export default __webpack_public_path__ + "static/media/paranas_seal.a4e1df60.png";